import React, {useEffect, useState} from 'react';
// import Download from "../components/OpenApp/Download";
import styled from "styled-components";
import bwmodel from '@/config/bwmodel'
import iosPng from '../../img/open_bower_ios.png'
import androidPng from '../../img/open_bower_android.png'
import { fetchWeixinCode } from '@/api/base'
import  {Base64 }  from 'js-base64/base64.js';
import { DetailToBrowser } from './style';
export const isWechat = bwmodel.app === 'weixin';
export default function App (props)  {
  const [imgUrl, setImgUrl] = useState('');
  const [status, setStatus] = useState(false);
  // bottom
  useEffect(()=>{
    const imgUrl = bwmodel.system === 'iPhone' ? iosPng : androidPng
    setImgUrl(imgUrl)
    init();
  },[])
  function init() {
    if(isWechat) {
      initWeChat2()
    } 

    console.log(initWeChat);
  }

  function initWeChat2() {
    const href = window.location.href;
 

    let result = Base64.encode(props.url||href)
    let schemeUrl = 'storm://app/webview?url=' + result;

    // schemeUrl = 'storm://app/marketQuotations?subTabName=strategy'

    const info = {
        eleId: 'eleId',
        content: '打开APP',
        appid: "wx7012bd486f3fe3f9",
      //   appid: res.appId,
      
        launchEvent(e){
          console.log('launch event',e);
        },
        extinfo: schemeUrl,
        errorEvent(e) {
          console.log('launch errorEvent',JSON.stringify(e.detail));
          if(e.detail.errMsg === "launch:fail") {
            window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.paiba.app000004';
            // if(bwmodel.system === 'iPhone') {
            //   window.location.href = 'https://apps.apple.com/cn/app/id1171026238'
            // } else {
              // window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.paiba.app000004';
            // }
          }
        }
      }
      launchApp(info) 
  }
    function initWeChat() {
      const href = window.location.href;
      const params = {
        url: href
      }

      let result = Base64.encode(props.url||href)
          
      let schemeUrl = 'storm://app/webview?url=' + result

      fetchWeixinCode(params)
        .then(({data:res}) => {
          if(window.wx) {
          // h5Share.appWxId = data.appId
            window.wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.appId, // 必填，服务号
              timestamp: res.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.nonceStr, // 必填，生成签名的随机串
              signature: res.signature, // 必填，签名，见附录1
              openTagList: ['wx-open-launch-app'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
              jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData','onMenuShareQZone']
            })
        


            window.wx.error(function (res) {

                // 刷新签名并重新配置
                console.log('error',res);
                // refreshSignatureAndConfig();
              
              });

              window.wx.ready(function (res) {

                // 刷新签名并重新配置
                console.log("ready", res);
                // refreshSignatureAndConfig();
              
              });
              
            const info = {
              eleId: 'eleId',
              content: '打开APP',
              appid: "wx7012bd486f3fe3f9",
            //   appid: res.appId,
            
              launchEvent(e){
                console.log('launch event',e);
              },
              extinfo: `{"path":"${schemeUrl}"}`,
              errorEvent(e) {
                console.log('launch errorEvent',JSON.stringify(e.detail));
              }
            }
            launchApp(info) 

           
          }
        })
      }
      
  //  <script type='text/wxtag-template'>
  function launchApp(info) {
    
    var container = document.getElementById('eleId');
    let script = document.createElement("script"); 
    script.type = "text/wxtag-template"; 
    script.text = info.content
    
    let html = `
      <wx-open-launch-app id="launch-btn" style="width:150px;height:100%;display:block;" appid="${info.appid}" extinfo="${info.extinfo}">
      <script type='text/wxtag-template'>
      <button 
          class='btn' 
            style="background-color: #ffc800;
            margin:auto;
            color: #fff;
            border-radius: 18px;
            border: none;
            font-size: 17px;
            line-height: 20px;
            padding: 8px 20px;
            z-index: 100;
            text-align: center;
            font-weight: 400;
            display: flex;
            justify-self: center;
            
            box-shadow: 0 2px 16px 0 rgba(0, 0, 0, .2);"
          >
          <img style='width: 20px;height: 20px;margin-right: 6px;border-radius: 4px;' src='https://file.wogoo.com/app/logo/new_logo.png' alt="logo" />
          App内查看
        </button>
     </script>
      </wx-open-launch-app>
      `;
    container.innerHTML = html;

    var btn = document.getElementById('launch-btn'); 
    btn.addEventListener("launch", info.launchEvent);
    btn.addEventListener("error", info.errorEvent);
    
  }

  function handleOpenApp() {
    if ((bwmodel.app === 'weibo' || bwmodel.app === 'dingtalk') && bwmodel.system === 'Android') {

      setStatus(true);
        
    } else if (bwmodel.system === 'iPhone') {
        const url = props.url ||  window.location.href;
       
        let universalUrl = 'webview?baseURL=' + Base64.encode(url)
      
        let appOpenUrl = process.env.REACT_APP_appOpenUrl 
    
        window.location.href = appOpenUrl + universalUrl
    } else {
        const url = props.url ||  window.location.href;
        let result = Base64.encode(url)
        let schemeUrl = encodeURIComponent('storm://app/webview?url=' + result)
        const downloadUrl = 'https://m.wogoo.com/app/download/wogoo_client/index.html';
        window.location.href = downloadUrl + '?ios_scheme=' + schemeUrl + '&android_scheme=' + schemeUrl
      }

  }
  return (
    <React.Fragment>
      {isWechat ?<div id='eleId' style={{position:'fixed',zIndex: '100',bottom:'100px',left: '50%',marginLeft: '-60px'}}></div>
        : <OpenAppBox style={{bottom :props.bottom && `${props.bottom}px`}} onClick={()=> {
          handleOpenApp()
        }}><img  src='https://file.wogoo.com/app/logo/new_logo.png' alt="logo" />
          打开APP</OpenAppBox>
      }

    <DetailToBrowser className={status?'show':''} onClick={()=>{setStatus(false)}} >
        <img src={imgUrl} alt='' />
      </DetailToBrowser>
    </React.Fragment>
  )
}



export const OpenAppBox = styled.div`
  
  position: fixed;
  left: 50%;
  bottom: 36px;
  margin-left: -60px;
  z-index: 100;

  background-color: #ffc800;
  color: #fff;
 
  border-radius: 18px;
  border: none;
  font-size: 17px;
  line-height: 20px;
  padding: 8px 20px;
  z-index: 100;
  text-align: center;
  font-weight: 400;
  display: flex;
  justify-self: center;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, .2);
}
img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
  border-radius: 4px;

}
`





// WEBPACK FOOTER //
// ./src/components/OpenApp/index.js